export default "__VITE_ASSET__Yo11EUbE__"